import axios from 'axios'
import authHeader from '@/http/auth.header'
import roleAccessManager from '@/utils/role-access-manager'
import roleAccessService from '@/http/role-access'

class AuthService {
  async login (user: any) {
    try {
      const response = await axios.post('/data/months.json', {
        email: user.email,
        password: user.password
      })
      if (response.data.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user))
        localStorage.setItem('accessToken', JSON.stringify(response.data.data.token))
        localStorage.setItem('refreshToken', JSON.stringify(response.data.data.refresh_token))
        
        // Store role_access jika ada
        if (response.data.data.role_access) {
          roleAccessManager.setRoleAccess(response.data.data.role_access)
        }
      }
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async token (data: any) {
    try {
      const url = '/auth/signature'
      const response = await axios.post(url, data)
      if (response.data.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user))
        localStorage.setItem('accessToken', JSON.stringify(response.data.data.token))
        localStorage.setItem('refreshToken', JSON.stringify(response.data.data.refresh_token))
        axios.defaults.headers.common = authHeader()
        
        // Store role_access jika ada
        if (response.data.data.role_access) {
          roleAccessManager.setRoleAccess(response.data.data.role_access)
        }
      }
      return response.data
    } catch (e) {
      console.error(e)
      return false
    }
  }

  async refreshAccessToken () {
    try {
      const url = '/auth/refresh'
      const response = await axios.post(url)
      if (response.data.data.token) {
        localStorage.setItem('accessToken', JSON.stringify(response.data.data.token))
        
        // Store role_access jika ada
        if (response.data.data.role_access) {
          roleAccessManager.setRoleAccess(response.data.data.role_access)
        }
      }
      return response.data
    } catch (e) {
      console.error(e)
      return false
    }
  }

  async authLogin (data: any) {
    try {
      const url = '/auth/login'
      const response = await axios.post(url, data)
      if (response.data.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user))
        localStorage.setItem('accessToken', JSON.stringify(response.data.data.token))
        localStorage.setItem('refreshToken', JSON.stringify(response.data.data.refresh_token))
        axios.defaults.headers.common = authHeader()
        
        // Store role_access jika ada
        if (response.data.data.role_access) {
          roleAccessManager.setRoleAccess(response.data.data.role_access)
        }
      }
      return response.data
    } catch (e) {
      console.error(e)
      return false
    }
  }

  /**
   * Start auto-update untuk role_access
   * Called from main.ts on app initialization
   */
  startRoleAccessAutoUpdate(onDataChanged?: () => void): void {
    try {
      const activeRoleId = this.getActiveRoleId()
      if (!activeRoleId) return

      roleAccessManager.startAutoUpdate(async () => {
        try {
          const response = await roleAccessService.getPermissions(activeRoleId)
          
          // Handle berbagai response format
          if (response.data && Array.isArray(response.data)) {
            return response.data
          } else if (response.data && Array.isArray(response.data.permissions)) {
            return response.data.permissions
          } else if (Array.isArray(response)) {
            return response
          }
          
          return []
        } catch (error) {
          console.error('Error fetching role access during auto-update:', error)
          return []
        }
      }, onDataChanged)
    } catch (error) {
      console.error('Error starting role access auto-update:', error)
    }
  }

  /**
   * Get active_role_id dari user data di localStorage
   */
  private getActiveRoleId(): number | null {
    try {
      const userData = localStorage.getItem('user')
      if (userData) {
        const user = JSON.parse(userData)
        return user?.active_role_id || null
      }
    } catch (error) {
      console.error('Error retrieving active role id:', error)
    }
    return null
  }

  async checkChild (data: any) {
    try {
      const url = '/auth/check-child'
      const response = await axios.post(url, data)
      return response.data
    } catch (e) {
      console.error(e)
      return false
    }
  }

  logout () {
    localStorage.removeItem('user')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    
    // Clear role_access saat logout
    roleAccessManager.clearRoleAccess()
  }
}

export const authService = new AuthService()
